import { memo, useEffect } from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ".././inner.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

function TendonMuscleInjuries() {
  useEffect(() => {
    document.title = "Tendon Injuries and Muscle Strains | Viksha Health Care";
    const newMetaDescription =
      "Treatment for tendon injuries and muscle strains at Viksha Health Care. Evaluation, pain relief, and a structured rehabilitation plan.";
    const metaTag = document.querySelector('meta[name="description"]');
    if (metaTag) {
      metaTag.setAttribute("content", newMetaDescription);
    }
  }, []);

  return (
    <>
      <h2 style={{ fontSize: "0px" }}>Tendon Injuries and Muscle Strains</h2>
      <div className="serinfobox">
        <div className="serinfoimg">
          <LazyLoadImage src="/photo/Tendon-Injuries-and-Muscle-Strains.avif" />
        </div>
        <div className="textareaofser">
          <h1>Tendon Injuries and Muscle Strains</h1>

          <p>
            Tendons connect muscles to bones, while muscles help move and
            stabilize the body. Injuries to these structures are common during
            sports, physical work, or sudden movements. Early diagnosis and
            proper treatment can reduce pain, promote healing, and prevent
            long-term problems.
          </p>

          <h5>Common Causes</h5>
          <ul>
            <li>Sudden overstretching during physical activity</li>
            <li>Repetitive strain from overuse</li>
            <li>Improper warm-up before exercise</li>
            <li>Lifting heavy objects incorrectly</li>
            <li>Direct impact or trauma</li>
          </ul>

          <h5>Symptoms</h5>
          <ul>
            <li>Pain at the site of injury</li>
            <li>Swelling or tenderness</li>
            <li>Muscle weakness</li>
            <li>Stiffness or limited movement</li>
            <li>Bruising in more severe cases</li>
          </ul>

          <h5>Evaluation and Diagnosis</h5>
          <p>
            A detailed physical examination helps assess the severity of the
            strain or tendon injury. In some cases, imaging tests may be advised
            to rule out more serious damage.
          </p>

          <h5>Treatment Options</h5>

          <h6>Early Care</h6>
          <p>
            Resting the injured area and avoiding activities that cause pain are
            important in the initial phase of recovery.
          </p>

          <h6>Non-Surgical Management</h6>
          <p>
            Most tendon injuries and muscle strains improve with non-surgical
            treatment. This may include medications for pain relief, supportive
            bandages or braces, and physiotherapy to restore strength and
            flexibility.
          </p>

          <h6>Physiotherapy and Rehabilitation</h6>
          <p>
            Guided exercises help regain muscle strength, improve flexibility,
            and reduce the risk of future injury. Gradual return to activity is
            important for safe recovery.
          </p>

          <h6>Surgical Treatment (Rare Cases)</h6>
          <p>
            Surgery is rarely required but may be considered in cases of
            complete tendon rupture or severe muscle injury.
          </p>

          <h5>Preventing Tendon and Muscle Injuries</h5>
          <ul>
            <li>Warm up properly before exercise</li>
            <li>Increase activity intensity gradually</li>
            <li>Maintain good flexibility and muscle strength</li>
            <li>Use proper techniques during sports and lifting</li>
          </ul>

          <p>
            Early treatment and proper rehabilitation can help you recover fully
            and return to your normal activities with reduced risk of re-injury.
          </p>
        </div>
      </div>
    </>
  );
}

export default memo(TendonMuscleInjuries);
